import { css } from '@emotion/css';
import { MTypography } from 'src/lib';
import { ScreenBreakpoint, TextAlign } from 'src/styles';

import { CardLayout } from '../../lib/Layout/CardLayout/CardLayout';

const closeAccountSubtitle = css`
  && {
    ${TextAlign.center}
  }

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    && {
      ${TextAlign.left}
    }
  }
`;

export const CloseAccount = () => {
  return (
    <CardLayout
      cardTitle='Account Closing Request'
      cardSubtitle={
        <MTypography variant='subtitle1' className={closeAccountSubtitle}>
          If you would like to close your account, please contact{' '}
          <a href='mailto:clientservices@myipo.com'>clientservices@myipo.com</a> and your request will be processed.
        </MTypography>
      }>
      <></>
    </CardLayout>
  );
};
